import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { ReactComponent as SearchIcon } from "../../assets/icons/marketing/greenSearch.svg";
import { ReactComponent as ClickIcon } from "../../assets/icons/marketing/greenClick.svg";
import { ReactComponent as MessageIcon } from "../../assets/icons/marketing/greenMessage.svg";
import { ReactComponent as ClockIcon } from "../../assets/icons/marketing/greenClock.svg";

const MarketingLessWaste = () => {
  return (
    <FullPageContainer>
      <Container>
        <Content>
          <TextWrapper>
            <Title>Less Waste. More Wins. Clear ROI.</Title>
            <Subtitle>
              Built for mobile marketing teams who are tired of guesswork,
              broken links, and siloed data, Grovs brings all your acquisition,
              engagement, and attribution tools into one powerful platform.
            </Subtitle>
            <Subtitle
              style={{ color: lightThemeColors.darkColor, fontWeight: "600" }}
            >
              Grovs helps marketers hit goals, cut waste, and scale faster—with
              less effort and zero code.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ContentBox>
              <BoxItem>
                <SearchIcon /> <p>Track what drives installs.</p>
              </BoxItem>
              <BoxItem>
                <ClickIcon />{" "}
                <p>Turn clicks into conversions with deep links.</p>
              </BoxItem>
              <BoxItem>
                <MessageIcon /> <p>Personalized messaging across platforms.</p>
              </BoxItem>
              <BoxItem>
                <ClockIcon /> <p>Optimize every campaign in real time.</p>
              </BoxItem>
            </ContentBox>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default MarketingLessWaste;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
    text-align: center;
  }
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
  overflow: hidden;
`;
const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 30px 20px;
  border-radius: 10px;
  border: 1px solid rgba(237, 235, 234, 1);
  width: 100%;
`;
const BoxItem = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  p {
    color: ${lightThemeColors.darkColor};
    font-weight: 600;
    font-size: 20px;
    line-height: 26px;
  }
  svg {
    height: 35px;
    width: 35px;
  }
`;
